@if (showBaseMapProviderToggle()) {
  <div id="baseMapProviderToggle">
    <mat-button-toggle-group
      name="baseMapProvider"
      [value]="viewTab()"
      (change)="onViewTabChange($event.value)"
    >
      <mat-button-toggle value="inventa">Inventa</mat-button-toggle>
      <mat-button-toggle value="esri">ArcGIS</mat-button-toggle>
    </mat-button-toggle-group>
  </div>
}

@if (viewTab() === 'esri') {
  @if (canAddLayers()) {
    <div id="esriFeatureLayers">
      @for (layer of visibleFeatureLayers(); track layer.key) {
        <div class="layer-row">
          <input
            type="checkbox"
            [checked]="layer.checked"
            (change)="onFeatureLayerToggle(layer.key, $event)"
          />
          <button
            type="button"
            class="layer-name"
            [matTooltip]="isTruncated(layer.label) ? layer.label : ''"
            matTooltipPosition="left"
            (click)="onFeatureLayerClick(layer)"
          >
            {{ truncateLabel(layer.label) }}
          </button>
        </div>
      }
      @if (featureLayers().length > visibleItemsLimit && !showAllFeatureLayers()) {
        <button type="button" class="show-more-link" (click)="showAllFeatureLayers.set(true)">
          Show more ({{ featureLayers().length - visibleItemsLimit }})
        </button>
      }
      <button type="button" mat-button id="addFeatureLayer" (click)="addLayers()">
        <mat-icon>add</mat-icon>
        <span>Add Layer</span>
      </button>
    </div>
  }
} @else {
  <div>
    @for (layer of inventaLayers(); track layer.id) {
      <label
        [matTooltip]="layerTooltip(layer.id)"
        [matTooltipDisabled]="!layerTooltip(layer.id)"
        matTooltipPosition="left"
      >
        <input
          type="checkbox"
          [(ngModel)]="this[layer.id]"
          (ngModelChange)="onLayerToggle(layer.id)"
          [disabled]="isLayerDisabled(layer.id)"
        />
        {{ layer.label }}
      </label>
    }
  </div>
}

@if (visibleBaseTiles().length) {
  <hr />
  <!-- One logical base-tile list spanning both tabs: a single shared
       selection, whichever tab it was picked from. -->
  <div id="baseTiles">
    @for (tile of visibleBaseTiles(); track tile.key) {
      <label [matTooltip]="tile.label" matTooltipPosition="left">
        <input
          type="radio"
          name="baseTile"
          [value]="tile.key"
          [checked]="activeTileKey() === tile.key"
          (change)="onBaseTileChange(tile.key)"
        />
        {{ tile.label }}
      </label>
    }
  </div>
}

@if (showEsriLogin() && viewTab() === 'esri') {
  <hr />
  <button type="button" class="login-link" (click)="login()">ArcGIS Login</button>
} @else if (showEsriLogout() && viewTab() === 'esri') {
  <hr />
  <button
    type="button"
    class="login-link logout-link"
    [matTooltip]="signedInAs()"
    matTooltipPosition="left"
    (click)="logout()"
  >
    Sign out of ArcGIS
  </button>
}
